<template>
  	<FlexEditBatch />
</template>

<script>

// @ is an alias to /src
import FlexEditBatch from "@/components/Flex/EditBatch.vue";

export default {
  name: "FlexEditBatchs",
  components: {
    FlexEditBatch,
  },
};
</script>
